export default class DonationResult {

    static get selector() {
      return '.donationResult--multi';
    }
    
    constructor(el) {
        this.el = el;
        this.options = this.getOptions();
        this.container = el.querySelector('.donationResult__optionList')
        this.setEvents();
        this.active(this.options[0]);
    }

    getOptions() {
        let selectors = this.el.querySelectorAll('.donationResult__selectorItem');
        let options = [];
        selectors.forEach( selector => {
            let option = {};
                option.selector = selector;
                option.id = selector.getAttribute('href');
                option.el = this.el.querySelector(option.id);
                option.isActive = false;
            options.push(option);
        });
        return options;
    }

    active(option) {
        if(option.isActive) return;
        this.desactiveAll();
        option.selector.classList.add('donationResult__selectorItem--active');
        option.el.classList.add('donationResult__option--active');
        this.setMinHeight(option);
        option.isActive = true;
    }

    desactive(option) {
        if(!option.isActive) return;
        option.selector.classList.remove('donationResult__selectorItem--active');
        option.el.classList.remove('donationResult__option--active');
        option.isActive = false;
    }

    desactiveAll() {
        this.options.forEach( option => {
            if(option.isActive) {
                this.desactive(option);
            }
        });
    }

    setMinHeight(option) {

        this.container.style.minHeight = option.el.offsetHeight +'px';

    }


    /**
     * Events
     */
    setEvents() {
        this.options.forEach( option => {
            option.selector.addEventListener('click', (e) => { this.e_click(e, option); }, false);
        });
    }

    e_click(e, option) {
        e.preventDefault();
        e.target.blur();
        console.log(option);
        this.active(option);
    }

}
